import { render, staticRenderFns } from "./trsTermsService.vue?vue&type=template&id=4fe5c393&scoped=true"
import script from "./trsTermsService.vue?vue&type=script&lang=js"
export * from "./trsTermsService.vue?vue&type=script&lang=js"
import style0 from "./trsTermsService.vue?vue&type=style&index=0&id=4fe5c393&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5c393",
  null
  
)

export default component.exports